import { render } from "./DetailsModal.vue?vue&type=template&id=9f018b88&scoped=true"
import script from "./DetailsModal.vue?vue&type=script&lang=js"
export * from "./DetailsModal.vue?vue&type=script&lang=js"

import "./DetailsModal.vue?vue&type=style&index=0&id=9f018b88&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f018b88"]])

export default __exports__